import React, { Component } from 'react';
import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../FundMonitoring.css';

class CiticRiskMonitoringGrid extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          columnDefs: [
            { headerName: 'Fund Code', field: 'fundCode', filter: 'agTextColumnFilter' },
            { headerName: 'Base Date', field: 'baseReportDate', filter: 'agDateColumnFilter' },
            { 
                headerName: 'Base Value', 
                field: 'baseValue',
                valueFormatter: params => params.value ? params.value.toFixed(4) + '%' : '-'
            },
            { headerName: 'Query Date', field: 'queryDate', filter: 'agDateColumnFilter' },
            { 
                headerName: 'New Ratio', 
                field: 'newRatio',
                valueFormatter: params => params.value ? (params.value * 100).toFixed(4) + '%' : '-'
            },
            { 
                headerName: 'Final Ratio', 
                field: 'finalRatio',
                valueFormatter: params => params.value ? params.value.toFixed(4) + '%' : '-'
            },
          ],
          defaultColDef: {
            enableCellChangeFlash: true,
            minWidth: 100,
            sortable: true,
            filter: true,
            resizable: true,
          },
        };
    }

    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        // 如果需要导出功能，可以像 TradesReview 那样把 grid 保存到 props
        if (this.props.addGridToProps) {
            this.props.addGridToProps(params);
        }
    }

    render() {
        const {
            queryCiticRiskMonitoringStatus,
            citicRiskMonitoringList,
        } = this.props;

        const isLoading = queryCiticRiskMonitoringStatus === ACTION_STATUS.LOGINING;

        return (
            <div className={`ag-theme-balham grid-wrapper`} style={{ height: 'calc(100vh - 250px)', width: '100%' }}>
                {isLoading ? (
                    <Loader active content="Loading..." />
                ) : (
                <AgGridReact
                    columnDefs={this.state.columnDefs}
                    rowData={citicRiskMonitoringList}
                    defaultColDef={this.state.defaultColDef}
                    animateRows={true}
                    onGridReady={this.onGridReady}
                    sideBar={true}
                />
                )}
            </div>
        );
    }
}

export default CiticRiskMonitoringGrid;
